import { TextSelection, PluginKey, Plugin } from 'prosemirror-state';
import { NodeExtension } from '../../../core/index.js';
import { v4 } from 'uuid';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import { Fragment } from 'prosemirror-model';
import { createInstance } from '@sailor/i18n-web';
import React, { Component } from 'react';
import ReactDOM, { render } from 'react-dom';

/**
 * Backspace 键的 keycode
 */ var KEY_CODE_BACKSPACE = 8;
/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var ZERO_WIDTH_SPACE = "​";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var noop = function() {};
var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, _toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function insertStatus(attrs) {
    return function(state, dispatch, view) {
        var tr = state.tr, schema = state.schema, selection = state.selection;
        var $from = selection.$from, from = selection.from;
        var status = schema.nodes.status;
        if (!canInsertTypes(state)) {
            return false;
        }
        var selectedkey = v4();
        var node = status.create(_objectSpread({
            input: true,
            selectedkey: selectedkey
        }, attrs || {}), schema.text(ZERO_WIDTH_SPACE));
        // TODO: 链接中插入状态宏的行为是否需要
        // 链接中插入状态宏的时候会在选区开始位置多创建一个链接关闭标签，所以此处做了特殊处理
        var plus = $from.parent.type.name === "link" ? 3 : 2;
        tr.replaceWith(from, from, node);
        var newSelection = TextSelection.create(tr.doc, from + plus);
        tr.setSelection(newSelection);
        dispatch(tr);
        view.focus();
        return true;
    };
}

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var AFTER_INSERT = "after_insert";

var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(Keycodes || (Keycodes = {}));

function checkZero(text) {
    return text === ZERO_WIDTH_SPACE;
}
function isSelectStatus() {
    var selection = window.getSelection();
    return selection.focusNode && selection.focusNode.classList && selection.focusNode.classList.contains("ct-status");
}
function handleBackspace(param) {
    var state = param.state, dispatch = param.dispatch, view = param.view;
    var tr = state.tr, schema = state.schema, selection = state.selection;
    var status = schema.nodes.status;
    var $cursor = selection.$cursor, $from = selection.$from, from = selection.from, to = selection.to;
    var statusInfo = findParentNode(function(node) {
        return node.type === status;
    })(selection);
    if (statusInfo) {
        if ($cursor) {
            var cursorNodeBefore = $cursor.nodeBefore;
            var isZeroBefore = cursorNodeBefore && checkZero(cursorNodeBefore.text);
            if (isZeroBefore || !cursorNodeBefore) {
                // 光标在状态宏内最前端时不删除状态宏
                return true;
            }
        } else {
            var isFocusStatus = isSelectStatus();
            var nodeBefore = $from.nodeBefore;
            var trueFrom = from;
            if (!isFocusStatus) {
                // 拖动选中了文字
                if (!nodeBefore) {
                    trueFrom += 1; // 选中了零宽字符要少删一个字符
                }
                tr.delete(trueFrom, to);
                tr.setSelection(TextSelection.create(tr.doc, trueFrom));
                dispatch(tr);
                view.focus();
                return true;
            }
            if (!nodeBefore) {
                dispatch(tr.setSelection(TextSelection.create(tr.doc, trueFrom + 1, to)));
                return false;
            }
        }
    }
    // if ($cursor) {
    // GapCursor的情况下没有$cursor这个属性
    // 下面关于GapCursor的处理无需处理 在base-key-map-extension的util中的deleteSelectedNode方法已经有统一处理
    // 下面的处理有可能会带来  targetDOM.getBoundingClientRect is not a function的js error 导致删除行为被截断，发生失焦
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/64990562
    /**
   * <span>零宽字符</span>字
   * 从 字 后面的pos开始删除，from - 3的位置在零宽字符之前<span>之后
   */ // const textPos = from - 3;
    // if (textPos < 0) {
    //   return false;
    // }
    // const textNode = tr.doc.nodeAt(textPos);
    // if (textNode && textNode.type.name === "text") {
    //   // 状态宏节点的起点statusPos为<span>前
    //   const statusPos = textPos - textNode.nodeSize;
    //   if (statusPos < 0) {
    //     return false;
    //   }
    //   const statusNode = tr.doc.nodeAt(statusPos);
    //   if (statusNode && statusNode.type === status) {
    //     tr.delete(from - 1, from);
    //     // 在状态宏结束位置（</span>后一个位置）显示GapCursor
    //     const newSelection = new GapCursor(tr.doc.resolve(from - 1));
    //     dispatch(tr.setSelection(newSelection));
    //     return true;
    //   }
    // }
    // }
    return false;
}
var handleEnter = function(param) {
    var state = param.state, dispatch = param.dispatch, view = param.view;
    var tr = state.tr, schema = state.schema, selection = state.selection;
    var status = schema.nodes.status;
    var foundNode = findParentNode(function(node) {
        return node.type === status;
    })(selection);
    if (foundNode) {
        var node = foundNode.node, pos = foundNode.pos;
        var newSelection = TextSelection.create(tr.doc, pos + node.nodeSize);
        dispatch(tr.setSelection(newSelection));
        view.focus();
        return true;
    }
    return false;
};

var locale = "en";
var version = 16;
var cannot_search_user = "User not found, click space to complete input";
var load_fail_retry = "Failed to load, please try again later";
var pk_avatar = "avatar";
var mention_by_mis_name = "Can @user by name and MIS number";
var searching = "Searching...";
var pk_link_text = "Text";
var insert_blank = "Insert";
var pk_visit_link = "Access the link";
var pk_link_address = "Address";
var pk_link = "Link";
var cancel_blank = "Cancel";
var pk_link_change_tip = "Link text follows the Doc change";
var pk_edit_link = "Edit link";
var pk_link_text_tip = "Input the link text";
var pk_cancel_link = "Cancel link";
var save_blank = "Save";
var pk_link_address_tip = "Input the link address";
var border = "Border";
var pk_insert = "Insert";
var image_link = "Image Link";
var pk_retry = "Retry";
var pk_edit = "Edit";
var width = "Width";
var reupload = "Reupload";
var image_upload_fail1 = "Sorry, upload error!";
var right_address_tip = "Please input right address";
var image_upload_fail3 = "Otherwise, please click button below to retry.";
var image_upload_fail2 = "If the image is moved/pasted from outside, please download and reupload.";
var pk_confirm = "Confirm";
var input_html = "Enter HTML code.";
var formual = "Formual";
var pk_loading = "Loading...";
var click_to_expand = "Click to expand the content";
var pk_cancel = "Cancel";
var input_html_tip = "You can insert HTML code to embed corresponding content on a webpage.";
var input_latex = "Enter Latex code";
var insert_latex_tip = "You can insert Latex code to embed corresponding content within the page.";
var pk_title = "Title";
var wire_frame = "Wireframe";
var fill_in = "Fill";
var input_plantuml = "Enter PlantUML code.";
var border_style = "Border type";
var set_th_line = "Header Column";
var set_th_row = "Header Row";
var table_attr = "Table style";
var cancel_th_line = "Cancel Header Column";
var insert_line_right = "Right Insert Column";
var insert_row = "Delete Rows";
var split_cell = "Split cells";
var delete_line = "Delete Columns";
var pk_no = "No borders";
var input_markdown_tip = "You can insert Markdown code to embed corresponding content within the page.";
var confirm_blank = "Confirm";
var cancel_th_row = "Cancel Header Row";
var insert_row_above = "Insert Row Above";
var delete_table = "Delete";
var input_plantuml_tip = "You can insert PlantUML code to embed corresponding content within the page.";
var border_width = "Border width";
var input_markdown = "Enter Markdown code.";
var merge_cell = "Merge cells";
var set_line_num = "Show Row Number";
var border_color = "Border color";
var insert_line_left = "Left Insert Column";
var insert_row_below = "Insert Row Below";
var cancel_line_num = "Cancel Row Number";
var exit_data_lost_tip = "If you exit, any unsaved data will be lost.";
var if_exit_gantt = "Are you sure to exit the Gantt chart?";
var pk_gantt_loading = "Loading Gantt chart...";
var gantt_load_fail = "Gantt chart loading failed.";
var operate_error = "Invalid operation";
var gantt_keep_work_tip = "Please keep at least one task.";
var save_success = "Save successful";
var gantt_frame_load_fail = "Gantt chart framework failed to load.";
var pk_network_exception = "Network exception";
var save_fail = "Save failed";
var pk_saving = "Saving...";
var gantt_plugin_fail = "Gantt chart editing plugin failed to start.";
var gantt_editing_tip = "Editing Gantt Chart, please wait a moment.";
var pk_discard = "Drop";
var pk_zoom_in = "Zoom in";
var pk_zoom_out = "Zoom out";
var pk_use = "Use";
var draft_edit_tip = "There is a draft that was edited but not saved on {time}. Do you want to continue editing?";
var if_use_local_draft = "Do you use local drafts?";
var pk_load_fail = "Loading failed";
var pk_this_time = "Now";
var choose_time = "Select time";
var pk_hh_mm_ss = "hh:mm:ss A";
var pk_y_d = "MM-DD-YYYY";
var pk_y_d_ts = "MM-DD-YYYY hh:mm:ss A";
var pk_text = "Text";
var h1 = "Heading 1";
var h2 = "Heading 2";
var h3 = "Heading 3";
var h4 = "Heading 4";
var h5 = "Heading 5";
var h6 = "Heading 6";
var pk_catalog = "Catalog";
var page_view_load_fail_click = "Directory tree loading failed. Please click to reload.";
var page_tree_no_sub_doc = "No sub documents found in this directory";
var page_tree_no_perm = "No permission to view the directory tree.";
var pk_load_fail_retry = "Loading failed, please click to reload.";
var loading2 = "Loading";
var page_tree_deleted = "The directory tree has been deleted.";
var pk_pause = "Pause";
var pk_mute = "Mute";
var pk_untitled = "Untitled";
var pk_play = "Play";
var adjust_volume = "Adjust volume";
var download_fail_retry = "Download failed please retry";
var pk_download = "Download";
var get_file_fail = "Failed to get file";
var pk_network_fail = "Network connection failed";
var pk_upload_fail = "Upload failed";
var audio_not_support_tip = "This browser does not support the HTML5 audio tag.";
var pk_volume = "Volume";
var browser_not_support_tip = "This browser does not support the HTML5 video tag.";
var pk_zoom_in2 = "Zoom in";
var video_upload_tip = "Video is being transcoded, if the file is large, it may take a long time. Please wait patiently...";
var pk_video = "Video";
var pk_zoom_out2 = "Zoom out";
var space_update_fail_tip = "Space update acquisition failed. Click to retry.";
var pk_recent_update = "Recent Updates";
var show_more = "Show More";
var no_space_update = "No Updates in Space.";
var pk_restore = "Restore";
var en_parker = {
    locale: locale,
    version: version,
    cannot_search_user: cannot_search_user,
    load_fail_retry: load_fail_retry,
    pk_avatar: pk_avatar,
    mention_by_mis_name: mention_by_mis_name,
    searching: searching,
    pk_link_text: pk_link_text,
    insert_blank: insert_blank,
    pk_visit_link: pk_visit_link,
    pk_link_address: pk_link_address,
    pk_link: pk_link,
    cancel_blank: cancel_blank,
    pk_link_change_tip: pk_link_change_tip,
    pk_edit_link: pk_edit_link,
    pk_link_text_tip: pk_link_text_tip,
    pk_cancel_link: pk_cancel_link,
    save_blank: save_blank,
    pk_link_address_tip: pk_link_address_tip,
    border: border,
    pk_insert: pk_insert,
    image_link: image_link,
    pk_retry: pk_retry,
    pk_edit: pk_edit,
    width: width,
    reupload: reupload,
    image_upload_fail1: image_upload_fail1,
    right_address_tip: right_address_tip,
    image_upload_fail3: image_upload_fail3,
    image_upload_fail2: image_upload_fail2,
    pk_confirm: pk_confirm,
    input_html: input_html,
    formual: formual,
    pk_loading: pk_loading,
    click_to_expand: click_to_expand,
    pk_cancel: pk_cancel,
    input_html_tip: input_html_tip,
    input_latex: input_latex,
    insert_latex_tip: insert_latex_tip,
    pk_title: pk_title,
    wire_frame: wire_frame,
    fill_in: fill_in,
    input_plantuml: input_plantuml,
    border_style: border_style,
    set_th_line: set_th_line,
    set_th_row: set_th_row,
    table_attr: table_attr,
    cancel_th_line: cancel_th_line,
    insert_line_right: insert_line_right,
    insert_row: insert_row,
    split_cell: split_cell,
    delete_line: delete_line,
    pk_no: pk_no,
    input_markdown_tip: input_markdown_tip,
    confirm_blank: confirm_blank,
    cancel_th_row: cancel_th_row,
    insert_row_above: insert_row_above,
    delete_table: delete_table,
    input_plantuml_tip: input_plantuml_tip,
    border_width: border_width,
    input_markdown: input_markdown,
    merge_cell: merge_cell,
    set_line_num: set_line_num,
    border_color: border_color,
    insert_line_left: insert_line_left,
    insert_row_below: insert_row_below,
    cancel_line_num: cancel_line_num,
    exit_data_lost_tip: exit_data_lost_tip,
    if_exit_gantt: if_exit_gantt,
    pk_gantt_loading: pk_gantt_loading,
    gantt_load_fail: gantt_load_fail,
    operate_error: operate_error,
    gantt_keep_work_tip: gantt_keep_work_tip,
    save_success: save_success,
    gantt_frame_load_fail: gantt_frame_load_fail,
    pk_network_exception: pk_network_exception,
    save_fail: save_fail,
    pk_saving: pk_saving,
    gantt_plugin_fail: gantt_plugin_fail,
    gantt_editing_tip: gantt_editing_tip,
    pk_discard: pk_discard,
    pk_zoom_in: pk_zoom_in,
    pk_zoom_out: pk_zoom_out,
    pk_use: pk_use,
    draft_edit_tip: draft_edit_tip,
    if_use_local_draft: if_use_local_draft,
    pk_load_fail: pk_load_fail,
    pk_this_time: pk_this_time,
    choose_time: choose_time,
    pk_hh_mm_ss: pk_hh_mm_ss,
    pk_y_d: pk_y_d,
    pk_y_d_ts: pk_y_d_ts,
    pk_text: pk_text,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    pk_catalog: pk_catalog,
    page_view_load_fail_click: page_view_load_fail_click,
    page_tree_no_sub_doc: page_tree_no_sub_doc,
    page_tree_no_perm: page_tree_no_perm,
    pk_load_fail_retry: pk_load_fail_retry,
    loading2: loading2,
    page_tree_deleted: page_tree_deleted,
    pk_pause: pk_pause,
    pk_mute: pk_mute,
    pk_untitled: pk_untitled,
    pk_play: pk_play,
    adjust_volume: adjust_volume,
    download_fail_retry: download_fail_retry,
    pk_download: pk_download,
    get_file_fail: get_file_fail,
    pk_network_fail: pk_network_fail,
    pk_upload_fail: pk_upload_fail,
    audio_not_support_tip: audio_not_support_tip,
    pk_volume: pk_volume,
    browser_not_support_tip: browser_not_support_tip,
    pk_zoom_in2: pk_zoom_in2,
    video_upload_tip: video_upload_tip,
    pk_video: pk_video,
    pk_zoom_out2: pk_zoom_out2,
    space_update_fail_tip: space_update_fail_tip,
    pk_recent_update: pk_recent_update,
    show_more: show_more,
    no_space_update: no_space_update,
    pk_restore: pk_restore
};

var locale$1 = "zh";
var version$1 = 16;
var cannot_search_user$1 = "未搜索到用户，点击空格完成输入";
var load_fail_retry$1 = "加载失败，请稍后重试";
var pk_avatar$1 = "头像";
var mention_by_mis_name$1 = "可通过姓名及mis号@用户";
var searching$1 = "搜索中...";
var pk_link_text$1 = "链接文字";
var insert_blank$1 = "插 入";
var pk_link$1 = "链接";
var pk_link_address$1 = "链接地址";
var pk_visit_link$1 = "访问链接";
var cancel_blank$1 = "取 消";
var pk_link_change_tip$1 = "链接文字跟随文档标题变更";
var pk_edit_link$1 = "编辑链接";
var pk_cancel_link$1 = "取消链接";
var pk_link_text_tip$1 = "请输入链接文字";
var save_blank$1 = "保 存";
var pk_link_address_tip$1 = "请输入链接地址";
var border$1 = "边框";
var pk_insert$1 = "插入";
var image_link$1 = "图片链接";
var pk_edit$1 = "编辑";
var pk_retry$1 = "重试";
var width$1 = "宽度";
var reupload$1 = "重新上传";
var image_upload_fail1$1 = "抱歉，图片上传失败！";
var image_upload_fail3$1 = "否则，请点击下方按钮进行重试。";
var right_address_tip$1 = "请输入正确的地址";
var image_upload_fail2$1 = "如果是从外部拖动、粘贴过来的图片，请下载原图并重新上传。";
var pk_confirm$1 = "确定";
var input_html$1 = "输入HTML代码";
var formual$1 = "公式";
var pk_loading$1 = "正在加载中...";
var pk_cancel$1 = "取消";
var click_to_expand$1 = "点击展开内容";
var input_html_tip$1 = "可以插入HTML代码，以在页面内嵌入相应内容：";
var insert_latex_tip$1 = "可以插入Latex代码，以在页面内嵌入相应内容：";
var input_latex$1 = "输入Latex代码";
var pk_title$1 = "标题";
var wire_frame$1 = "线框";
var fill_in$1 = "填充";
var input_plantuml$1 = "輸入PlantUML代碼";
var border_style$1 = "边框样式";
var set_th_row$1 = "设置表头行";
var set_th_line$1 = "设置表头列";
var table_attr$1 = "表格属性";
var cancel_th_line$1 = "取消表头列";
var insert_row$1 = "删除行";
var insert_line_right$1 = "右侧插入列";
var split_cell$1 = "拆分单元格";
var delete_line$1 = "删除列";
var confirm_blank$1 = "确 定";
var input_markdown_tip$1 = "可以插入Markdown代码，以在页面内嵌入相应内容：";
var pk_no$1 = "无";
var cancel_th_row$1 = "取消表头行";
var insert_row_above$1 = "上方插入行";
var delete_table$1 = "删除表格";
var input_plantuml_tip$1 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容";
var border_width$1 = "边框宽度";
var input_markdown$1 = "输入Markdown代码";
var merge_cell$1 = "合并单元格";
var set_line_num$1 = "设置行号列";
var border_color$1 = "边框颜色";
var insert_line_left$1 = "左侧插入列";
var insert_row_below$1 = "下方插入行";
var cancel_line_num$1 = "取消行号列";
var if_exit_gantt$1 = "确定退出甘特图?";
var exit_data_lost_tip$1 = "退出后，尚未保存的数据将丢失。";
var gantt_load_fail$1 = "甘特图载入失败";
var pk_gantt_loading$1 = "甘特图载入中...";
var operate_error$1 = "您的操作有误";
var gantt_keep_work_tip$1 = "请至少保留一个任务";
var gantt_frame_load_fail$1 = "甘特图框架加载失败";
var save_success$1 = "保存成功";
var save_fail$1 = "保存失败";
var pk_network_exception$1 = "网络异常";
var pk_saving$1 = "正在保存中...";
var gantt_plugin_fail$1 = "甘特图编辑插件启动失败";
var gantt_editing_tip$1 = "正在编辑甘特图，请稍候再试噢。";
var pk_discard$1 = "废弃";
var pk_zoom_in$1 = "放大查看";
var pk_zoom_out$1 = "缩小查看";
var pk_use$1 = "使用";
var draft_edit_tip$1 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继续编辑";
var pk_load_fail$1 = "加载失败";
var if_use_local_draft$1 = "是否使用本地草稿？";
var pk_this_time$1 = "此刻";
var choose_time$1 = "选择时间";
var pk_hh_mm_ss$1 = "HH:mm:ss";
var pk_y_d$1 = "YYYY-MM-DD";
var pk_y_d_ts$1 = "YYYY-MM-DD HH:mm:ss";
var pk_text$1 = "正文";
var h1$1 = "标题 1";
var h2$1 = "标题 2";
var h3$1 = "标题 3";
var h4$1 = "标题 4";
var h5$1 = "标题 5";
var h6$1 = "标题 6";
var pk_catalog$1 = "目录";
var page_view_load_fail_click$1 = "目录树加载失败，请点击重新加载";
var page_tree_no_sub_doc$1 = "该目录下暂无子文档";
var page_tree_no_perm$1 = "无权查看该目录树";
var pk_load_fail_retry$1 = "加载失败，请点击重新加载";
var loading2$1 = "正在加载";
var page_tree_deleted$1 = "该目录树已被删除";
var pk_pause$1 = "暂停";
var pk_mute$1 = "静音";
var pk_untitled$1 = "未命名";
var pk_play$1 = "播放";
var adjust_volume$1 = "音量调节";
var download_fail_retry$1 = "下载失败，请重试";
var get_file_fail$1 = "文件获取失败";
var pk_download$1 = "下载";
var pk_network_fail$1 = "网络连接失败";
var pk_upload_fail$1 = "上传失败";
var audio_not_support_tip$1 = "本浏览器不支持 HTML5 audio 标签";
var browser_not_support_tip$1 = "本浏览器不支持 HTML5 video 标签";
var pk_volume$1 = "音量";
var pk_zoom_in2$1 = "放大";
var pk_video$1 = "视频";
var video_upload_tip$1 = "视频正在转码中，如文件较大可能时间较长，请耐心等待…";
var pk_zoom_out2$1 = "缩小";
var space_update_fail_tip$1 = "空间更新获取失败，点击重试";
var pk_recent_update$1 = "最近更新";
var show_more$1 = "显示更多";
var no_space_update$1 = "空间暂时没有动态～";
var pk_restore$1 = "恢复默认";
var zh_parker = {
    locale: locale$1,
    version: version$1,
    cannot_search_user: cannot_search_user$1,
    load_fail_retry: load_fail_retry$1,
    pk_avatar: pk_avatar$1,
    mention_by_mis_name: mention_by_mis_name$1,
    searching: searching$1,
    pk_link_text: pk_link_text$1,
    insert_blank: insert_blank$1,
    pk_link: pk_link$1,
    pk_link_address: pk_link_address$1,
    pk_visit_link: pk_visit_link$1,
    cancel_blank: cancel_blank$1,
    pk_link_change_tip: pk_link_change_tip$1,
    pk_edit_link: pk_edit_link$1,
    pk_cancel_link: pk_cancel_link$1,
    pk_link_text_tip: pk_link_text_tip$1,
    save_blank: save_blank$1,
    pk_link_address_tip: pk_link_address_tip$1,
    border: border$1,
    pk_insert: pk_insert$1,
    image_link: image_link$1,
    pk_edit: pk_edit$1,
    pk_retry: pk_retry$1,
    width: width$1,
    reupload: reupload$1,
    image_upload_fail1: image_upload_fail1$1,
    image_upload_fail3: image_upload_fail3$1,
    right_address_tip: right_address_tip$1,
    image_upload_fail2: image_upload_fail2$1,
    pk_confirm: pk_confirm$1,
    input_html: input_html$1,
    formual: formual$1,
    pk_loading: pk_loading$1,
    pk_cancel: pk_cancel$1,
    click_to_expand: click_to_expand$1,
    input_html_tip: input_html_tip$1,
    insert_latex_tip: insert_latex_tip$1,
    input_latex: input_latex$1,
    pk_title: pk_title$1,
    wire_frame: wire_frame$1,
    fill_in: fill_in$1,
    input_plantuml: input_plantuml$1,
    border_style: border_style$1,
    set_th_row: set_th_row$1,
    set_th_line: set_th_line$1,
    table_attr: table_attr$1,
    cancel_th_line: cancel_th_line$1,
    insert_row: insert_row$1,
    insert_line_right: insert_line_right$1,
    split_cell: split_cell$1,
    delete_line: delete_line$1,
    confirm_blank: confirm_blank$1,
    input_markdown_tip: input_markdown_tip$1,
    pk_no: pk_no$1,
    cancel_th_row: cancel_th_row$1,
    insert_row_above: insert_row_above$1,
    delete_table: delete_table$1,
    input_plantuml_tip: input_plantuml_tip$1,
    border_width: border_width$1,
    input_markdown: input_markdown$1,
    merge_cell: merge_cell$1,
    set_line_num: set_line_num$1,
    border_color: border_color$1,
    insert_line_left: insert_line_left$1,
    insert_row_below: insert_row_below$1,
    cancel_line_num: cancel_line_num$1,
    if_exit_gantt: if_exit_gantt$1,
    exit_data_lost_tip: exit_data_lost_tip$1,
    gantt_load_fail: gantt_load_fail$1,
    pk_gantt_loading: pk_gantt_loading$1,
    operate_error: operate_error$1,
    gantt_keep_work_tip: gantt_keep_work_tip$1,
    gantt_frame_load_fail: gantt_frame_load_fail$1,
    save_success: save_success$1,
    save_fail: save_fail$1,
    pk_network_exception: pk_network_exception$1,
    pk_saving: pk_saving$1,
    gantt_plugin_fail: gantt_plugin_fail$1,
    gantt_editing_tip: gantt_editing_tip$1,
    pk_discard: pk_discard$1,
    pk_zoom_in: pk_zoom_in$1,
    pk_zoom_out: pk_zoom_out$1,
    pk_use: pk_use$1,
    draft_edit_tip: draft_edit_tip$1,
    pk_load_fail: pk_load_fail$1,
    if_use_local_draft: if_use_local_draft$1,
    pk_this_time: pk_this_time$1,
    choose_time: choose_time$1,
    pk_hh_mm_ss: pk_hh_mm_ss$1,
    pk_y_d: pk_y_d$1,
    pk_y_d_ts: pk_y_d_ts$1,
    pk_text: pk_text$1,
    h1: h1$1,
    h2: h2$1,
    h3: h3$1,
    h4: h4$1,
    h5: h5$1,
    h6: h6$1,
    pk_catalog: pk_catalog$1,
    page_view_load_fail_click: page_view_load_fail_click$1,
    page_tree_no_sub_doc: page_tree_no_sub_doc$1,
    page_tree_no_perm: page_tree_no_perm$1,
    pk_load_fail_retry: pk_load_fail_retry$1,
    loading2: loading2$1,
    page_tree_deleted: page_tree_deleted$1,
    pk_pause: pk_pause$1,
    pk_mute: pk_mute$1,
    pk_untitled: pk_untitled$1,
    pk_play: pk_play$1,
    adjust_volume: adjust_volume$1,
    download_fail_retry: download_fail_retry$1,
    get_file_fail: get_file_fail$1,
    pk_download: pk_download$1,
    pk_network_fail: pk_network_fail$1,
    pk_upload_fail: pk_upload_fail$1,
    audio_not_support_tip: audio_not_support_tip$1,
    browser_not_support_tip: browser_not_support_tip$1,
    pk_volume: pk_volume$1,
    pk_zoom_in2: pk_zoom_in2$1,
    pk_video: pk_video$1,
    video_upload_tip: video_upload_tip$1,
    pk_zoom_out2: pk_zoom_out2$1,
    space_update_fail_tip: space_update_fail_tip$1,
    pk_recent_update: pk_recent_update$1,
    show_more: show_more$1,
    no_space_update: no_space_update$1,
    pk_restore: pk_restore$1
};

var locale$2 = "zh-HK";
var version$2 = 16;
var cannot_search_user$2 = "未能找到用户，請按空格鍵完成輸入";
var load_fail_retry$2 = "載入失敗，請稍後重試。";
var pk_avatar$2 = "頭像";
var mention_by_mis_name$2 = "可通過姓名及MIS號碼@用戶";
var searching$2 = "搜尋中...";
var pk_link_text$2 = "鏈接文字";
var insert_blank$2 = "插 入";
var pk_visit_link$2 = "访问鏈接";
var pk_link_address$2 = "鏈接地址";
var pk_link$2 = "鏈接";
var cancel_blank$2 = "取 消";
var pk_link_change_tip$2 = "鏈接文字跟隨文件標題變更";
var pk_edit_link$2 = "編輯鏈接";
var pk_link_text_tip$2 = "請輸入鏈接文字";
var pk_cancel_link$2 = "取消鏈接";
var save_blank$2 = "保 存";
var pk_link_address_tip$2 = "請輸入鏈接地址";
var border$2 = "邊框";
var pk_insert$2 = "插入";
var image_link$2 = "圖片鏈接";
var pk_retry$2 = "重試";
var pk_edit$2 = "編輯";
var width$2 = "寬度";
var reupload$2 = "重新上傳";
var image_upload_fail1$2 = "抱歉，圖片上傳失敗！";
var right_address_tip$2 = "請輸入正確的地址";
var image_upload_fail3$2 = "否則，請按下方按鈕進行重試。";
var image_upload_fail2$2 = "如果您從外部拖動、粘貼過來的圖片，請下載原圖並重新上傳。";
var pk_confirm$2 = "確定";
var input_html$2 = "輸入HTML代碼";
var formual$2 = "公式";
var pk_loading$2 = "正在載入中...";
var pk_cancel$2 = "取消";
var click_to_expand$2 = "點選展開內容";
var input_html_tip$2 = "可以插入HTML代碼，以在頁面內嵌入相應內容：";
var insert_latex_tip$2 = "可以插入Latex代碼，以在頁面內嵌入相應內容：";
var input_latex$2 = "输入LaTeX代码";
var pk_title$2 = "標題";
var wire_frame$2 = "線框";
var fill_in$2 = "填充";
var input_plantuml$2 = "輸入PlantUML程式碼";
var border_style$2 = "邊框樣式";
var set_th_row$2 = "設置表頭行";
var set_th_line$2 = "設置表頭列";
var table_attr$2 = "表格屬性";
var cancel_th_line$2 = "取消表頭列";
var insert_row$2 = "删除行";
var insert_line_right$2 = "右側插入列";
var split_cell$2 = "拆分儲存格";
var delete_line$2 = "删除列";
var pk_no$2 = "無";
var confirm_blank$2 = "確 定";
var input_markdown_tip$2 = "可以插入Markdown代碼，以在頁面內嵌入相應內容：";
var cancel_th_row$2 = "取消表頭行";
var insert_row_above$2 = "上方插入行";
var delete_table$2 = "刪除表格";
var input_plantuml_tip$2 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容：";
var border_width$2 = "邊框寬度";
var input_markdown$2 = "輸入Markdown代碼";
var merge_cell$2 = "合併儲存格";
var set_line_num$2 = "設置行号列";
var border_color$2 = "邊框顏色";
var insert_line_left$2 = "左側插入列";
var insert_row_below$2 = "下方插入行";
var cancel_line_num$2 = "取消行号列";
var if_exit_gantt$2 = "確定退出甘特圖?";
var exit_data_lost_tip$2 = "退出後，尚未儲存的數據將會遺失。";
var pk_gantt_loading$2 = "甘特圖載入中...";
var gantt_load_fail$2 = "甘特圖載入失敗";
var operate_error$2 = "您的操作有誤";
var gantt_keep_work_tip$2 = "請至少保留一個任務";
var save_success$2 = "保存成功";
var gantt_frame_load_fail$2 = "甘特圖框架載入失敗";
var save_fail$2 = "保存失敗";
var pk_network_exception$2 = "網絡異常";
var pk_saving$2 = "正在儲存中...";
var gantt_plugin_fail$2 = "甘特圖編輯插件啟動失敗。";
var gantt_editing_tip$2 = "正在編輯甘特圖，請稍後再試唷。";
var pk_discard$2 = "廢棄";
var pk_zoom_in$2 = "放大查看";
var pk_zoom_out$2 = "縮小查看";
var pk_use$2 = "使用";
var draft_edit_tip$2 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继續編輯";
var pk_load_fail$2 = "加載失敗";
var if_use_local_draft$2 = "是否使用本地草稿？";
var pk_this_time$2 = "此刻";
var choose_time$2 = "選擇時間";
var pk_hh_mm_ss$2 = "HH:mm:ss";
var pk_y_d$2 = "YYYY-MM-DD";
var pk_y_d_ts$2 = "YYYY-MM-DD HH:mm:ss";
var pk_text$2 = "正文";
var h1$2 = "標題 1";
var h2$2 = "標題 2";
var h3$2 = "標題 3";
var h4$2 = "標題 4";
var h5$2 = "標題 5";
var h6$2 = "標題 6";
var pk_catalog$2 = "目錄";
var page_view_load_fail_click$2 = "目錄樹加載失敗，請點擊重新加載。";
var page_tree_no_sub_doc$2 = "該目錄下暫無子文檔。";
var page_tree_no_perm$2 = "無權查看該目錄樹";
var pk_load_fail_retry$2 = "加載失敗，請點擊重新加載。";
var loading2$2 = "正在載入";
var page_tree_deleted$2 = "該目錄樹已被刪除";
var pk_pause$2 = "暫停";
var pk_mute$2 = "靜音";
var pk_untitled$2 = "未命名";
var pk_play$2 = "播放";
var adjust_volume$2 = "音量調節";
var download_fail_retry$2 = "下載失敗，請重試";
var pk_download$2 = "下載";
var get_file_fail$2 = "文件獲取失敗";
var pk_network_fail$2 = "網絡連接失敗";
var pk_upload_fail$2 = "上載失敗";
var audio_not_support_tip$2 = "本瀏覽器不支援 HTML5 audio 標籤";
var pk_volume$2 = "音量";
var browser_not_support_tip$2 = "本瀏覽器不支援 HTML5 video 標籤";
var pk_zoom_in2$2 = "放大";
var video_upload_tip$2 = "視頻正在轉碼中，如果文件較大可能需要較長的時間，請耐心等待...";
var pk_video$2 = "視頻";
var pk_zoom_out2$2 = "縮小";
var space_update_fail_tip$2 = "空間更新獲取失敗，點擊重試";
var pk_recent_update$2 = "最近更新";
var show_more$2 = "顯示更多";
var no_space_update$2 = "空間暫時沒有動態～";
var pk_restore$2 = "恢復預設";
var zhHK_parker = {
    locale: locale$2,
    version: version$2,
    cannot_search_user: cannot_search_user$2,
    load_fail_retry: load_fail_retry$2,
    pk_avatar: pk_avatar$2,
    mention_by_mis_name: mention_by_mis_name$2,
    searching: searching$2,
    pk_link_text: pk_link_text$2,
    insert_blank: insert_blank$2,
    pk_visit_link: pk_visit_link$2,
    pk_link_address: pk_link_address$2,
    pk_link: pk_link$2,
    cancel_blank: cancel_blank$2,
    pk_link_change_tip: pk_link_change_tip$2,
    pk_edit_link: pk_edit_link$2,
    pk_link_text_tip: pk_link_text_tip$2,
    pk_cancel_link: pk_cancel_link$2,
    save_blank: save_blank$2,
    pk_link_address_tip: pk_link_address_tip$2,
    border: border$2,
    pk_insert: pk_insert$2,
    image_link: image_link$2,
    pk_retry: pk_retry$2,
    pk_edit: pk_edit$2,
    width: width$2,
    reupload: reupload$2,
    image_upload_fail1: image_upload_fail1$2,
    right_address_tip: right_address_tip$2,
    image_upload_fail3: image_upload_fail3$2,
    image_upload_fail2: image_upload_fail2$2,
    pk_confirm: pk_confirm$2,
    input_html: input_html$2,
    formual: formual$2,
    pk_loading: pk_loading$2,
    pk_cancel: pk_cancel$2,
    click_to_expand: click_to_expand$2,
    input_html_tip: input_html_tip$2,
    insert_latex_tip: insert_latex_tip$2,
    input_latex: input_latex$2,
    pk_title: pk_title$2,
    wire_frame: wire_frame$2,
    fill_in: fill_in$2,
    input_plantuml: input_plantuml$2,
    border_style: border_style$2,
    set_th_row: set_th_row$2,
    set_th_line: set_th_line$2,
    table_attr: table_attr$2,
    cancel_th_line: cancel_th_line$2,
    insert_row: insert_row$2,
    insert_line_right: insert_line_right$2,
    split_cell: split_cell$2,
    delete_line: delete_line$2,
    pk_no: pk_no$2,
    confirm_blank: confirm_blank$2,
    input_markdown_tip: input_markdown_tip$2,
    cancel_th_row: cancel_th_row$2,
    insert_row_above: insert_row_above$2,
    delete_table: delete_table$2,
    input_plantuml_tip: input_plantuml_tip$2,
    border_width: border_width$2,
    input_markdown: input_markdown$2,
    merge_cell: merge_cell$2,
    set_line_num: set_line_num$2,
    border_color: border_color$2,
    insert_line_left: insert_line_left$2,
    insert_row_below: insert_row_below$2,
    cancel_line_num: cancel_line_num$2,
    if_exit_gantt: if_exit_gantt$2,
    exit_data_lost_tip: exit_data_lost_tip$2,
    pk_gantt_loading: pk_gantt_loading$2,
    gantt_load_fail: gantt_load_fail$2,
    operate_error: operate_error$2,
    gantt_keep_work_tip: gantt_keep_work_tip$2,
    save_success: save_success$2,
    gantt_frame_load_fail: gantt_frame_load_fail$2,
    save_fail: save_fail$2,
    pk_network_exception: pk_network_exception$2,
    pk_saving: pk_saving$2,
    gantt_plugin_fail: gantt_plugin_fail$2,
    gantt_editing_tip: gantt_editing_tip$2,
    pk_discard: pk_discard$2,
    pk_zoom_in: pk_zoom_in$2,
    pk_zoom_out: pk_zoom_out$2,
    pk_use: pk_use$2,
    draft_edit_tip: draft_edit_tip$2,
    pk_load_fail: pk_load_fail$2,
    if_use_local_draft: if_use_local_draft$2,
    pk_this_time: pk_this_time$2,
    choose_time: choose_time$2,
    pk_hh_mm_ss: pk_hh_mm_ss$2,
    pk_y_d: pk_y_d$2,
    pk_y_d_ts: pk_y_d_ts$2,
    pk_text: pk_text$2,
    h1: h1$2,
    h2: h2$2,
    h3: h3$2,
    h4: h4$2,
    h5: h5$2,
    h6: h6$2,
    pk_catalog: pk_catalog$2,
    page_view_load_fail_click: page_view_load_fail_click$2,
    page_tree_no_sub_doc: page_tree_no_sub_doc$2,
    page_tree_no_perm: page_tree_no_perm$2,
    pk_load_fail_retry: pk_load_fail_retry$2,
    loading2: loading2$2,
    page_tree_deleted: page_tree_deleted$2,
    pk_pause: pk_pause$2,
    pk_mute: pk_mute$2,
    pk_untitled: pk_untitled$2,
    pk_play: pk_play$2,
    adjust_volume: adjust_volume$2,
    download_fail_retry: download_fail_retry$2,
    pk_download: pk_download$2,
    get_file_fail: get_file_fail$2,
    pk_network_fail: pk_network_fail$2,
    pk_upload_fail: pk_upload_fail$2,
    audio_not_support_tip: audio_not_support_tip$2,
    pk_volume: pk_volume$2,
    browser_not_support_tip: browser_not_support_tip$2,
    pk_zoom_in2: pk_zoom_in2$2,
    video_upload_tip: video_upload_tip$2,
    pk_video: pk_video$2,
    pk_zoom_out2: pk_zoom_out2$2,
    space_update_fail_tip: space_update_fail_tip$2,
    pk_recent_update: pk_recent_update$2,
    show_more: show_more$2,
    no_space_update: no_space_update$2,
    pk_restore: pk_restore$2
};

// This file was auto generated by resource-sync tools.
var resources = {
    "en": {
        parker: en_parker
    },
    "zh": {
        parker: zh_parker
    },
    "zh-HK": {
        parker: zhHK_parker
    }
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var I18nManager = /*#__PURE__*/ function() {
    function I18nManager() {
        _classCallCheck(this, I18nManager);
    }
    I18nManager.getInstance = function getInstance() {
        if (this.instance === null) {
            this.instance = createInstance();
            this.instance.init({
                // lng: 'zh',
                fallbackLng: "zh",
                ns: [
                    "parker"
                ],
                defaultNS: "parker",
                resources: resources,
                interpolation: {
                    escapeValue: false
                },
                react: {
                    useSuspense: false
                }
            });
            window.parkerI18nClient = this.instance;
        }
        return this.instance;
    };
    return I18nManager;
}();
I18nManager.instance = null;
var i18nClient = I18nManager.getInstance();

var FONT_COLOR_DARK = "#333";
var FONT_COLOR_LIGHT = "#fff";
var colorsMore = [
    "#fff",
    "#333",
    "#f5222d",
    "#fa541c",
    "#faad14",
    "#fadb14",
    "#52c41a",
    "#13c2c2",
    "#1890ff",
    "#2f54eb",
    "#722ed1",
    "#eb2f96",
    "#f6f6f6",
    "#989898",
    "#ffe8e7",
    "#ffece0",
    "#fff7cb",
    "#fcfcca",
    "#e5f7d3",
    "#cffff7",
    "#d4eefc",
    "#dfe8fc",
    "#efe1fa",
    "#fbe1eb",
    "#e9e9e9",
    "#666",
    "#ffa39e",
    "#ffbb96",
    "#ffe58f",
    "#fffb8f",
    "#b7eb8f",
    "#87e8de",
    "#91d5ff",
    "#adc6ff",
    "#d3adf7",
    "#ffadd2",
    "#ddd",
    "#4b4b4b",
    "#ff4d4f",
    "#ff7a45",
    "#ffc53d",
    "#ffec3d",
    "#73d13d",
    "#36cfc9",
    "#40a8ff",
    "#597ef7",
    "#9254de",
    "#f759ab",
    "#ccc",
    "#262626",
    "#cf1322",
    "#d4380d",
    "#d48806",
    "#d4b106",
    "#389e0d",
    "#08979c",
    "#096dd9",
    "#1d39c4",
    "#531dab",
    "#c41d7f",
    "#aaa",
    "#000",
    "#820014",
    "#871400",
    "#874d00",
    "#876800",
    "#135200",
    "#00474f",
    "#003a8c",
    "#061178",
    "#22075e",
    "#780650"
];
var colors = [
    "#ccc",
    "#f5222d",
    "#fadb14",
    "#52c41a",
    "#1890ff"
];
var patterns = [
    {
        type: "fill",
        text: i18nClient.t("fill_in", "填充")
    },
    {
        type: "outline",
        text: i18nClient.t("wire_frame", "线框")
    }
];

var computeFontColor = function(color) {
    var index = colorsMore.findIndex(function(c) {
        return c === color;
    });
    if (index === -1) {
        return FONT_COLOR_DARK;
    }
    if (index % 12 < 1) {
        return FONT_COLOR_DARK;
    }
    if (index % 12 < 2) {
        return FONT_COLOR_LIGHT;
    }
    if (index > 11 && index < 36) {
        return FONT_COLOR_DARK;
    }
    return FONT_COLOR_LIGHT;
};
var createNodeView = function(node) {
    var dom = document.createElement("span");
    var _node_attrs = node.attrs, color = _node_attrs.color, pattern = _node_attrs.pattern;
    var style = "\n    background: ".concat(pattern === "fill" ? color : "#fff", ";\n    border-color: ").concat(color, ";\n    color: ").concat(pattern === "fill" ? computeFontColor(color) : "", ";\n  ");
    dom.setAttribute("class", classNamePrefix("status"));
    dom.setAttribute("style", style);
    dom.setAttribute("spellcheck", "false");
    return {
        dom: dom,
        contentDOM: dom
    };
};

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        render(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = ReactDOM.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
styleInject(css_248z);

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var SHOW = "show";
var HIDE = "hide";
var Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        _classCallCheck$1(this, Popover);
        this.popoverState = HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === SHOW && !forceUpdate) {
            return;
        }
        if (!target || !_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        render(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(HIDE);
    };
    _proto.destroy = function destroy() {
        emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
var DEFAULT_HEIGHT = 34;
var DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        _classCallCheck$2(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = _objectSpread$1({}, DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new Popover(_objectSpread$1({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var ColorPicker = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, colors = param.colors, selected = param.selected, onChange = param.onChange;
    return /*#__PURE__*/ React.createElement("div", {
        className: "color-group ".concat(className)
    }, colors.map(function(color) {
        return /*#__PURE__*/ React.createElement("div", {
            key: color,
            className: "item".concat(color === selected ? " selected" : ""),
            onClick: function() {
                return onChange(color);
            }
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                backgroundColor: color
            }
        }));
    }));
};

var css_248z$1 = '.ct-status-expand{display:flex;align-items:center}.ct-status-expand-btn{display:flex;width:26px;height:26px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2248px%22 height%3D%2248px%22 viewBox%3D%220 0 48 48%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 54.1 (76490) - https%3A%2F%2Fsketchapp.com --%3E    %3Ctitle%3Eellipsis%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cg id%3D%22ellipsis%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22%E5%8F%82%E8%80%83%E7%BA%BF%22 opacity%3D%220%22%3E            %3Cg%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 fill%3D%22%23FFFFFF%22 fill-rule%3D%22nonzero%22 x%3D%220%22 y%3D%220%22 width%3D%2248%22 height%3D%2248%22%3E%3C%2Frect%3E                %3Ccircle id%3D%22%E6%A4%AD%E5%9C%86%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2219.9%22%3E%3C%2Fcircle%3E                %3Ccircle id%3D%22%E6%A4%AD%E5%9C%86%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%229.9%22%3E%3C%2Fcircle%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 x%3D%226.1%22 y%3D%226.1%22 width%3D%2235.8%22 height%3D%2235.8%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 x%3D%228.1%22 y%3D%224.1%22 width%3D%2231.8%22 height%3D%2239.8%22 rx%3D%222%22%3E%3C%2Frect%3E                %3Crect id%3D%22%E7%9F%A9%E5%BD%A2%22 stroke%3D%22%23003CFF%22 stroke-width%3D%220.2%22 opacity%3D%220.600000024%22 fill-rule%3D%22nonzero%22 x%3D%224.1%22 y%3D%228.1%22 width%3D%2239.8%22 height%3D%2231.8%22 rx%3D%222%22%3E%3C%2Frect%3E            %3C%2Fg%3E        %3C%2Fg%3E        %3Cpath d%3D%22M11%2C21 C12.6568542%2C21 14%2C22.3431458 14%2C24 C14%2C25.6568542 12.6568542%2C27 11%2C27 C9.34314575%2C27 8%2C25.6568542 8%2C24 C8%2C22.3431458 9.34314575%2C21 11%2C21 Z M24%2C21 C25.6568542%2C21 27%2C22.3431458 27%2C24 C27%2C25.6568542 25.6568542%2C27 24%2C27 C22.3431458%2C27 21%2C25.6568542 21%2C24 C21%2C22.3431458 22.3431458%2C21 24%2C21 Z M37%2C21 C38.6568542%2C21 40%2C22.3431458 40%2C24 C40%2C25.6568542 38.6568542%2C27 37%2C27 C35.3431458%2C27 34%2C25.6568542 34%2C24 C34%2C22.3431458 35.3431458%2C21 37%2C21 Z%22 id%3D%22%E5%BD%A2%E7%8A%B6%22 fill%3D%22%23000000%22 fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") 50% no-repeat;background-size:16px 16px;cursor:pointer;margin:0 1px 0 -5px}';
styleInject(css_248z$1);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var CLS_PREFIX = classNamePrefix("status-expand");
var Expand = /*#__PURE__*/ function(Component) {
    _inherits(Expand, Component);
    var _super = _createSuper(Expand);
    function Expand(props) {
        _classCallCheck$3(this, Expand);
        var _this;
        _this = _super.call(this, props);
        _this.handleClick = function() {
            var _this_props = _this.props, _this_props_onExpand = _this_props.onExpand, onExpand = _this_props_onExpand === void 0 ? function() {
                return null;
            } : _this_props_onExpand;
            _this.setState({
                expand: true
            });
            onExpand();
        };
        _this.state = {
            expand: !!props.expand
        };
        return _this;
    }
    var _proto = Expand.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, _this_props_className = _this_props.className, className = _this_props_className === void 0 ? "" : _this_props_className, child = _this_props.child, children = _this_props.children;
        var expand = this.state.expand;
        return /*#__PURE__*/ React.createElement("div", {
            className: "".concat(CLS_PREFIX, " ").concat(className)
        }, expand ? child : children, expand ? null : /*#__PURE__*/ React.createElement("div", {
            className: "".concat(CLS_PREFIX, "-btn"),
            onClick: function() {
                return _this.handleClick();
            }
        }));
    };
    return Expand;
}(Component);

var PatternPicker = function(param) {
    var _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, patterns = param.patterns, selected = param.selected, onChange = param.onChange;
    return /*#__PURE__*/ React.createElement("div", {
        className: "pattern-group ".concat(className)
    }, patterns.map(function(p) {
        return /*#__PURE__*/ React.createElement("label", {
            className: "radio",
            key: p.type,
            onClick: function() {
                return onChange(p.type);
            }
        }, /*#__PURE__*/ React.createElement("span", {
            className: "radio-bg"
        }), /*#__PURE__*/ React.createElement("input", {
            type: "radio",
            checked: selected === p.type,
            readOnly: true
        }), " ", p.text, /*#__PURE__*/ React.createElement("span", {
            className: "radio-on"
        }));
    }));
};

var css_248z$2 = ".ct-status-editor{flex-direction:column;align-items:flex-start;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-status-editor .ct-status-editor-expand{display:flex;flex-direction:row}.ct-status-editor .color-group{height:38px;display:flex;justify-content:center;align-items:center}.ct-status-editor .color-group .item{width:26px;height:26px;margin:0 2px;display:flex;justify-content:center;align-items:center;cursor:pointer}.ct-status-editor .color-group .item.selected,.ct-status-editor .color-group .item:hover{border:1px solid #ccc;border-radius:2px}.ct-status-editor .color-group .item:first-child{margin:0 2px 0 4px}.ct-status-editor .color-group .item div{width:14px;height:14px}.ct-status-editor .color-group-large{width:244px;height:106px;flex-wrap:wrap;margin:9px 6px}.ct-status-editor .color-group-large .item{width:16px;height:16px;border:1px solid #eee;margin:1px 2px 0}.ct-status-editor .color-group-large .item.selected,.ct-status-editor .color-group-large .item:hover{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-status-editor .color-group-large .item:hover{z-index:3}.ct-status-editor .color-group-large .item:first-child{margin:1px 2px 0}.ct-status-editor .pattern-group{height:38px;display:flex;justify-content:flex-start;align-items:center;margin-left:12px}.ct-status-editor .pattern-group.large{padding-bottom:8px}.ct-status-editor .pattern-group .radio{display:inline-block;position:relative;font-size:14px;line-height:16px;margin-right:12px;cursor:pointer;color:rgba(0,0,0,.65)}.ct-status-editor .pattern-group .radio input{display:none}.ct-status-editor .pattern-group .radio .radio-bg{display:inline-block;height:16px;width:16px;margin-right:5px;padding:0;border-radius:100%;border:1px solid #00a7cd;vertical-align:top;cursor:pointer;transition:all .2s ease}.ct-status-editor .pattern-group .radio .radio-on{display:none}.ct-status-editor .pattern-group .radio input:checked+span.radio-on{width:8px;height:8px;position:absolute;border-radius:100%;background:#00a7cd;top:4px;left:4px;transition:all .2s ease;transform:scale(1);display:inline-block}";
styleInject(css_248z$2);

function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var CLS_PREFIX$1 = classNamePrefix("status");
var StatusEditor = /*#__PURE__*/ function(Component) {
    _inherits$1(StatusEditor, Component);
    var _super = _createSuper$1(StatusEditor);
    function StatusEditor(props) {
        _classCallCheck$4(this, StatusEditor);
        var _this;
        _this = _super.call(this, props);
        _this.handleClick = function(e) {
            e.nativeEvent.stopImmediatePropagation();
            e.stopPropagation();
        };
        _this.handleExpand = function() {
            var handleExpand = _this.props.handleExpand;
            _this.setState({
                expand: true
            });
            handleExpand && handleExpand();
        };
        _this.state = {
            expand: props.expand
        };
        return _this;
    }
    var _proto = StatusEditor.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, color = _this_props.color, pattern = _this_props.pattern, handleColorSelect = _this_props.handleColorSelect, handlePatternSelect = _this_props.handlePatternSelect;
        var expand = this.state.expand;
        return /*#__PURE__*/ React.createElement("div", {
            className: "".concat(CLS_PREFIX$1, "-editor"),
            onClick: function(e) {
                return _this.handleClick(e);
            }
        }, /*#__PURE__*/ React.createElement(Expand, {
            className: "".concat(CLS_PREFIX$1, "-editor-expand"),
            expand: expand,
            onExpand: function() {
                return _this.handleExpand();
            },
            child: /*#__PURE__*/ React.createElement(ColorPicker, {
                className: "color-group-large",
                colors: colorsMore,
                selected: color,
                onChange: function(c) {
                    return handleColorSelect(c, expand);
                }
            })
        }, /*#__PURE__*/ React.createElement(ColorPicker, {
            colors: colors,
            selected: color,
            onChange: function(c) {
                return handleColorSelect(c, expand);
            }
        })), /*#__PURE__*/ React.createElement(PatternPicker, {
            className: expand ? "large" : "",
            patterns: patterns,
            selected: pattern,
            onChange: function(p) {
                return handlePatternSelect(p, expand);
            }
        }));
    };
    return StatusEditor;
}(Component);

function _assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$2(self);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$2(this, result);
    };
}
var POPOVER_HEIGHT_FULL = 170;
var POPOVER_HEIGHT_MIN = 76;
var StylePopover = /*#__PURE__*/ function(PluginView) {
    _inherits$2(StylePopover, PluginView);
    var _super = _createSuper$2(StylePopover);
    function StylePopover() {
        _classCallCheck$5(this, StylePopover);
        var _this;
        _this = _super.apply(this, arguments);
        // 状态是否发生了改变
        _this.isChanged = false;
        _this.handleColorSelect = function(color, exp) {
            var expand = exp || !colors.includes(color);
            _this.setAttrs({
                color: color,
                expand: expand
            });
        };
        _this.handlePatternSelect = function(pattern, expand) {
            _this.setAttrs({
                pattern: pattern,
                expand: expand
            });
        };
        _this.handleExpand = function() {
            _this.setAttrs({
                expand: true
            });
        };
        _this.setAttrs = function(newAttrs) {
            var node = _this.findSelectNode().node;
            var pos = _this.currentPos;
            if (!node) {
                return;
            }
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var tr = state.tr;
            try {
                var attrs = _objectSpread$2({}, node.attrs, newAttrs);
                tr.setNodeMarkup(pos, null, attrs);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
            _this.isChanged = true;
            dispatch(tr);
        };
        return _this;
    }
    var _proto = StylePopover.prototype;
    _proto.shouldUpdate = function shouldUpdate() {
        if (this.isChanged) {
            this.isChanged = false;
            return true;
        }
        return false;
    };
    _proto.findSelectNode = function findSelectNode() {
        var view = this.view;
        var state = view.state;
        var selection = state.selection;
        var nodeType = state.schema.nodes.status;
        var selectedNode = state.selection.node;
        if (selectedNode && selectedNode.type === nodeType) {
            return {
                pos: state.selection.from,
                node: selectedNode
            };
        }
        var found = findParentNode(function(node) {
            return node.type === nodeType;
        })(selection);
        if (found) {
            return found;
        }
        return null;
    };
    _proto.getNode = function getNode() {
        var found = this.findSelectNode();
        this.currentNode = found === null || found === void 0 ? void 0 : found.node;
        this.currentPos = found === null || found === void 0 ? void 0 : found.pos;
        if (found) {
            return this.view.nodeDOM(found.pos);
        }
        return null;
    };
    _proto.getContent = function getContent() {
        var node = this.currentNode;
        if (!node) {
            return null;
        }
        var _node_attrs = node.attrs, color = _node_attrs.color, expand = _node_attrs.expand, pattern = _node_attrs.pattern;
        return /*#__PURE__*/ React.createElement(StatusEditor, {
            color: color,
            expand: expand,
            pattern: pattern,
            handleColorSelect: this.handleColorSelect,
            handlePatternSelect: this.handlePatternSelect,
            handleExpand: this.handleExpand
        });
    };
    _proto.getHeight = function getHeight() {
        var node = this.currentNode;
        if (!node) {
            return 0;
        }
        var expand = node.attrs.expand;
        return expand ? POPOVER_HEIGHT_FULL : POPOVER_HEIGHT_MIN;
    };
    return StylePopover;
}(PluginView);

var css_248z$3 = '.ct-status{display:inline-block;word-break:break-all;min-height:22px;min-width:68px;padding:0 8px;margin:0 2px;vertical-align:bottom;font-size:12px;font-weight:700;line-height:18px;text-align:center;color:#000;background-color:#ccc;border:2px solid #ccc;border-radius:2px;cursor:text}.ct-status[data-color=red]{background-color:#f5222d;border-color:#f5222d}.ct-status[data-color=red][data-pattern=fill]{color:#fff}.ct-status[data-color=yellow]{background-color:#fadb14;border-color:#fadb14}.ct-status[data-color=yellow][data-pattern=fill]{color:#876800}.ct-status[data-color=green]{background-color:#52c41a;border-color:#52c41a}.ct-status[data-color=green][data-pattern=fill]{color:#fff}.ct-status[data-color=blue]{background-color:#1890ff;border-color:#1890ff}.ct-status[data-color=blue][data-pattern=fill]{color:#fff}.ct-status[data-pattern=outline]{background-color:#f7f7f7}.ct-status.ProseMirror-selectednode{outline:unset}.ct-status.ct-selected,.ct-status.ProseMirror-selectednode,.ct-status:hover{position:relative}.ct-status.ct-selected:after,.ct-status.ProseMirror-selectednode:after,.ct-status:hover:after{z-index:2;position:absolute;content:"";left:-3px;right:-3px;top:-3px;bottom:-3px;border:2px solid #23bdd9;border-radius:3px;pointer-events:none}.ct-status[data-selectedkey]{cursor:default}.ProseMirror-selectednode .ct-status{outline:2px solid #0082a6}.ProseMirror-widget+span.ct-status{top:auto}';
styleInject(css_248z$3);

function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$3(self);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1();
}
var _typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$3(this, result);
    };
}
// const lastSelectStatus = null;
var StatusExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$3(StatusExtension, NodeExtension);
    var _super = _createSuper$3(StatusExtension);
    function StatusExtension() {
        _classCallCheck$6(this, StatusExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.commands = function(param) {
            var getState = param.getState, editorEventEmitter = param.editorEventEmitter;
            return {
                insert: execAfterCommands(insertStatus, function() {
                    return editorEventEmitter.emit(AFTER_INSERT, {
                        braceWidth: 90
                    });
                }),
                isDisabled: function() {
                    return function() {
                        return !canInsertTypes(getState());
                    };
                }
            };
        };
        return _this;
    }
    var _proto = StatusExtension.prototype;
    _proto.plugin = function plugin() {
        var composing = null;
        return new Plugin({
            key: new PluginKey(this.name),
            props: {
                nodeViews: {
                    status: function(node) {
                        return createNodeView(node);
                    }
                },
                handleClickOn: function(view, pos, node, nodePos) {
                    var dispatch = view.dispatch, state = view.state;
                    var schema = state.schema, tr = state.tr, selection = state.selection;
                    var status = schema.nodes.status;
                    if (selection && node.type.name === status.name) {
                        // 点击状态宏区域
                        if (nodePos === pos - 1) {
                            // 点击状态宏内部左侧
                            var newSelection = TextSelection.create(tr.doc, nodePos + 2);
                            tr.setSelection(newSelection);
                            dispatch(tr);
                        } else if (nodePos === node.nodeSize + nodePos - 1) {
                            // 点击状态宏内部右侧
                            var newSelection1 = TextSelection.create(tr.doc, node.nodeSize + nodePos - 1);
                            tr.setSelection(newSelection1);
                            dispatch(tr);
                        }
                        view.focus();
                        return true;
                    }
                    // 如果点击状态宏内部文字TODO
                    return false;
                },
                // 之前的处理，暂时没有用到，先保留观察
                // handleClickOn: (view, pos, node, nodePos) => {
                //   const { dispatch, state } = view;
                //   const { schema, tr, selection } = state;
                //   const { status } = schema.nodes;
                //   try {
                //     if (selection && node.type.name === status.name) {
                //       if (!lastSelectStatus) {
                //         const newSelection = NodeSelection.create(tr.doc, nodePos);
                //         tr.setSelection(newSelection);
                //         dispatch(tr);
                //       } else if (
                //         lastSelectStatus.selectedkey === node.attrs.selectedkey
                //       ) {
                //         let newPos = pos;
                //         const { nodeBefore } = selection.$from;
                //         if (!nodeBefore) {
                //           // 此时光标在零宽字符前，需修正
                //           newPos += 1;
                //         }
                //         tr.setSelection(TextSelection.create(tr.doc, newPos));
                //         if (
                //           (tr.selection as NodeSelection).node ||
                //           tr.selection.$from.parent.type.name !== status.name
                //         ) {
                //           // 没有正确定位到里
                //           tr.setSelection(TextSelection.create(tr.doc, newPos - 1));
                //         }
                //         view.dispatch(tr);
                //         view.focus();
                //       }
                //       return true;
                //     }
                //   } catch (err) {
                //     // eslint-disable-next-line no-console
                //     console.error(err);
                //   }
                //   return false;
                // },
                handleDOMEvents: {
                    cut: function(view) {
                        var _view_state = view.state, selection = _view_state.selection, schema = _view_state.schema, tr = _view_state.tr;
                        var status = schema.nodes.status;
                        var $from = selection.$from, $to = selection.$to, from = selection.from, to = selection.to;
                        var selectStatusFrom = $from.parent && $from.parent.type === status && $from.parent;
                        var selectStatusTo = $to.parent && $to.parent.type === status && $to.parent;
                        var statusNode = selectStatusFrom || selectStatusTo;
                        // 状态宏 size 包含零宽度字符，加上开始节点
                        var rangeSize = Math.abs(to - from) + 3;
                        // 如果选择区域包含状态宏，且选区等于或超出状态宏的大小，
                        // 可能的情况是选区开始在状态宏里，或选区结束在状态宏里
                        if ((selectStatusFrom || selectStatusTo) && rangeSize >= statusNode.nodeSize) {
                            try {
                                var _TextSelection;
                                // 下列计算过程包含零宽度字符的长度
                                var pos = [];
                                if (rangeSize === statusNode.nodeSize) {
                                    pos = [
                                        from - 2,
                                        to + 1
                                    ]; // 选中状态宏
                                } else if (selectStatusFrom) {
                                    pos = [
                                        from - 2,
                                        to
                                    ]; // 从后往前选，状态宏在最前
                                } else if (selectStatusTo) {
                                    pos = [
                                        from,
                                        to + 1
                                    ]; // 从前往后选，状态宏在最后
                                }
                                var newSelection = (_TextSelection = TextSelection).create.apply(_TextSelection, [
                                    tr.doc
                                ].concat(_toConsumableArray$1(pos)));
                                view.dispatch(tr.setSelection(newSelection));
                            // 这个地方不能return true，否则会导致后续复制内容不会走clipboardSerializer钩子方法
                            } catch (err) {
                                // eslint-disable-next-line no-console
                                console.error(err);
                            }
                        }
                        return false;
                    },
                    compositionstart: function(view) {
                        var state = view.state, dispatch = view.dispatch;
                        var tr = state.tr, schema = state.schema;
                        var selection = state.selection;
                        if (selection.gapCursorType === "afterInlineNode" && selection.targetNode && selection.targetNode.type === schema.nodes.status) {
                            // 如果当前为中文输入，且选区为状态宏后方的 GapCursor，需要动态创建一个零宽度字符进行占位
                            // 否则会出现中文进入到状态宏内部的情况。https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/41581776
                            composing = {
                                pos: selection.anchor
                            };
                            dispatch(tr.insertText(ZERO_WIDTH_SPACE).setSelection(TextSelection.create(tr.doc, selection.anchor + 1)));
                        }
                        return false;
                    },
                    compositionend: function(view) {
                        if (composing) {
                            var _view_state_doc_nodeAt, _view_state_doc_nodeAt_text;
                            // 如果当前为中文输入，且选区为状态宏后方的 GapCursor，需要在输入完成后清除动态创建的零宽度字符
                            var state = view.state, dispatch = view.dispatch;
                            var tr = state.tr;
                            if ((_view_state_doc_nodeAt = view.state.doc.nodeAt(composing.pos)) === null || _view_state_doc_nodeAt === void 0 ? void 0 : (_view_state_doc_nodeAt_text = _view_state_doc_nodeAt.text) === null || _view_state_doc_nodeAt_text === void 0 ? void 0 : _view_state_doc_nodeAt_text.startsWith(ZERO_WIDTH_SPACE)) {
                                // 增加零宽度字符的判断，防止删除错误
                                dispatch(tr.delete(composing.pos, composing.pos + 1));
                            }
                            composing = null;
                        }
                        return false;
                    },
                    keydown: function(view, e) {
                        var state = view.state, dispatch = view.dispatch;
                        var tr = state.tr, schema = state.schema, selection = state.selection;
                        var from = selection.from, $from = selection.$from, to = selection.to;
                        var status = schema.nodes.status;
                        var node = selection.node;
                        var keyCode = e.keyCode || e.which;
                        if (keyCode === KEY_CODE_BACKSPACE) {
                            return false;
                        }
                        // 此时为选中状态宏，非中文输入法时覆盖原有内容
                        if (node && node.type === status) {
                            tr.setSelection(// 设置选区为零宽度字符之后的文本区域
                            TextSelection.create(tr.doc, from + 2, from + node.nodeSize - 1));
                            dispatch(tr);
                            return true;
                        }
                        // 选择内部文字进行输入
                        if ($from.parent && $from.parent.type === status && !$from.nodeBefore) {
                            // 设置选区到零宽度字符之后的位置
                            tr.setSelection(TextSelection.create(tr.doc, from + 1, to));
                            dispatch(tr);
                            return true;
                        }
                        return false;
                    }
                }
            },
            view: function(view) {
                return new StylePopover(view, {
                    bottomFirst: true
                });
            }
        });
    };
    _proto.keys = function keys() {
        return {
            Backspace: handleBackspace,
            "Mod-Backspace": handleBackspace,
            // Delete: handleBackspace, delete行为不应该应用backspace的逻辑，暂时注释，需要后续明确定义delete的规则，再做处理
            // "Mod-Delete": handleBackspace,
            Enter: handleEnter,
            Tab: handleEnter
        };
    };
    _proto.clipboardSerializer = function clipboardSerializer(param) {
        var type = param.type;
        var toDOM = type.spec.toDOM;
        return _defineProperty$3({}, type.name, function(node) {
            var outputSpec = toDOM(node);
            // 参考文档 https://prosemirror.net/docs/ref/#model.DOMOutputSpec
            if (node.textContent.indexOf(ZERO_WIDTH_SPACE) !== 0 && outputSpec.length > 2 && outputSpec[2] === 0) {
                return [
                    outputSpec[0],
                    outputSpec[1],
                    [
                        "span",
                        ZERO_WIDTH_SPACE
                    ],
                    [
                        "span",
                        0
                    ]
                ];
            }
            return outputSpec;
        });
    };
    _proto.clipboardParser = function clipboardParser(param) {
        var type = param.type;
        var parseDOM = type.spec.parseDOM;
        return parseDOM.map(function(_) {
            return _objectSpreadProps(_objectSpread$3({}, _), {
                node: type.name,
                getContent: function(dom, schema) {
                    var textContent = dom.textContent;
                    var node = schema.text("".concat(textContent.indexOf(ZERO_WIDTH_SPACE) === 0 ? "" : ZERO_WIDTH_SPACE).concat(textContent));
                    return Fragment.from(node);
                }
            });
        });
    };
    _createClass(StatusExtension, [
        {
            key: "name",
            get: function get() {
                return "status";
            }
        }
    ]);
    return StatusExtension;
}(NodeExtension);

export { StatusExtension };
//# sourceMappingURL=index.js.map
